<template>
  <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">PFI Information</v-stepper-step>

      <v-divider></v-divider>
      <v-stepper-step step="2">Contact Person</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <PfiInformation v-on:emitForm1="goNextStep"></PfiInformation>
      </v-stepper-content>

      <v-stepper-content v-if="e1==2" step="2">
        <ContactPerson v-on:emitForm2="goNextStep"></ContactPerson>
      </v-stepper-content>

    </v-stepper-items>
  </v-stepper>
</template>

<script>
let commonService = require("../../../services/common.service");

import PfiInformation from './step_forms/pfiInformation';
import ContactPerson from './step_forms/contactPerson';
export default {
  components: {
    PfiInformation,
    ContactPerson,
  },
  data() {
    return {
      e1: 0,
    };
  },
  created() {
   
  },
  methods:{

    goNextStep(num)
    {
      this.e1 = num
    }
  },

};
</script>


// WEBPACK FOOTER //
// src/components/lending/PFI/dataTable.vue